import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { ExpencesActivitiesSchema } from "../../types"

type ExpencesActivitiesType = {
  year_month: string
  location_id: string
}
export function useExpencesActivitiesListFixed(params: ExpencesActivitiesType) {
  const api = useApi()
  const [data, setData] = useState<ExpencesActivitiesSchema | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: ExpencesActivitiesType): void => {
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/expenses_activities/fixed_expenses/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: ExpencesActivitiesSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/expenses_activities/fixed_expenses/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: ExpencesActivitiesSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}

export function useExpencesActivitiesListVariable(params: ExpencesActivitiesType) {
  const api = useApi()
  const [data, setData] = useState<ExpencesActivitiesSchema | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: ExpencesActivitiesType): void => {
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/expenses_activities/variable_expenses/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: ExpencesActivitiesSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/expenses_activities/variable_expenses/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: ExpencesActivitiesSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}

export function useExpencesActivitiesListOther(params: ExpencesActivitiesType) {
  const api = useApi()
  const [data, setData] = useState<ExpencesActivitiesSchema | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: ExpencesActivitiesType): void => {
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/expenses_activities/other_expenses/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: ExpencesActivitiesSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/expenses_activities/other_expenses/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: ExpencesActivitiesSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}